import { all, call, put, takeLatest } from 'redux-saga/effects';
import envConfig from '../../config';
import { request } from '../../common/util/RestClient';
import {
  saveNotificationPreferences,
  fetchNotificationPreferences,
} from '../routines/notificationRoutines';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

export function* saveNotificationPreferencesSaga({ payload }) {
  try {
    const { notificationPreferences, userId } = payload;
    const URL = `${envConfig.APIG_URL}notification/users/${userId}/notificationPreferences`;
    const config = {
      method: 'PATCH',
      payload: notificationPreferences,
    };
    yield call(request, URL, config);
    yield put(
      saveNotificationPreferences.success({
        notificationPreferences,
        successMessage: SUCCESS_MESSAGES.SAVE_NOTIFICATION_SETTINGS,
      })
    );
  } catch (error) {
    yield put(saveNotificationPreferences.failure({ error }));
  } finally {
    yield put(saveNotificationPreferences.fulfill());
  }
}

export function* fetchNotificationPreferencesSaga({ payload }) {
  try {
    const { userId } = payload;
    const URL = `${envConfig.APIG_URL}notification/users/${userId}/notificationPreferences`;
    const response = yield call(request, URL);
    yield put(
      fetchNotificationPreferences.success({
        notificationPreferences: response.data,
      })
    );
  } catch (error) {
    yield put(fetchNotificationPreferences.failure({ error }));
  } finally {
    yield put(fetchNotificationPreferences.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(
      saveNotificationPreferences.TRIGGER,
      saveNotificationPreferencesSaga
    ),
    takeLatest(
      fetchNotificationPreferences.TRIGGER,
      fetchNotificationPreferencesSaga
    ),
  ]);
}
